import {
  Interceptor,
  PromiseClient,
  createPromiseClient,
} from "@connectrpc/connect";
import { createGrpcWebTransport } from "@connectrpc/connect-web";

import { CheckoutFrontendV1Service } from "../generated-connect-es/checkout/fe/v1/checkout_fe_api_connect";
import {
  createVersionHeaderInterceptor,
  headerInterceptor,
} from "./header-interceptor";

export const getFeClient = (
  baseUrl: string,
  target = "NA",
  version: string
): PromiseClient<typeof CheckoutFrontendV1Service> => {
  const logger: Interceptor = (next) => async (req) => {
    console.debug(`sending message to ${req.url} with message`, req.message);
    const res = await next(req);
    if (!res.stream) {
      console.debug("response:", res.message);
    }
    return res;
  };

  // Default interceptors
  const interceptors = [
    headerInterceptor,
    createVersionHeaderInterceptor(version),
  ];

  // If dev or local log req and res
  if (
    baseUrl.includes("local") ||
    baseUrl.includes("dev") ||
    target === "c7-local" ||
    target === "c7-dev"
  ) {
    interceptors.push(logger);
  }

  const transport = createGrpcWebTransport({
    baseUrl,
    interceptors,
  });

  return createPromiseClient<typeof CheckoutFrontendV1Service>(
    CheckoutFrontendV1Service,
    transport
  );
};
